import type { ReadonlyTransaction, Transaction } from '@atlaskit/editor-prosemirror/state';

/**
 * Maps start position through transaction
 * Biases left (-1) to keep start stable
 */
export function mapStartPos({ pos, tr }: { pos: number; tr: ReadonlyTransaction | Transaction }): number {
	let mappedPos = tr.mapping.map(pos, -1);

	// Special handling for AI streaming transformation
	if (tr.getMeta('isAIStreamingTransformation')) {
		if (mappedPos > pos) {
			const adjustedPos = tr.mapping.map(pos - 1, -1) + 1;
			if (adjustedPos === pos) {
				mappedPos = pos;
			}
		}
	}

	return mappedPos;
}

/**
 * Maps end position through transaction
 * Biases right (1) to expand with content
 */
export function mapToPos({ pos, tr }: { pos: number; tr: ReadonlyTransaction | Transaction }): number {
	let mappedPos = tr.mapping.map(pos, 1);

	// Special handling for AI streaming transformation
	if (tr.getMeta('isAIStreamingTransformation')) {
		if (mappedPos === pos) {
			const adjustedPos = tr.mapping.map(pos + 1, 1) - 1;
			if (adjustedPos !== pos) {
				mappedPos = adjustedPos;
			}
		}
	}

	return mappedPos;
}
